import { doc } from 'firebase/firestore'
import { useMemo } from 'react'
import { db } from '../libs/Firebase'
import { useFirestoreQuery } from './useFirestoreQuery'
import { Collections } from '../../../pure-js/libs/Collections'
import { SystemConfigDocumentId } from '../../../pure-js/enums/SystemConfigDocumentId'
import { SystemConfig } from '../../../pure-js/types/SystemConfigTypes'
import { isSystemConfigEnabled } from '../../../pure-js/libs/SystemConfigHelper'

/**
 * Reads `system_config/hardCoupleSplitRegistration` (public-read in firestore.rules)
 * and evaluates whether split (V4) registration is enabled for the given client.
 */
export const useHardCoupleSplitRegistrationEnabled = (clientId: string | undefined): boolean => {
  const queryRef = useMemo(
    () => doc(db, Collections.SYSTEM_CONFIG, SystemConfigDocumentId.HARD_COUPLE_SPLIT_REGISTRATION),
    []
  )

  const { data } = useFirestoreQuery<SystemConfig>(queryRef, {
    fnName: 'useHardCoupleSplitRegistrationEnabled',
    enabled: !!clientId
  })

  return useMemo(() => {
    if (!data || !clientId) return false
    return isSystemConfigEnabled(data as SystemConfig, clientId)
  }, [data, clientId])
}
